module.exports = __webpack_public_path__ + "img/logo_small.d523f3d2.png";